/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tron_chain_about = () => `Tron is a blockchain platform focused on decentralized entertainment and content distribution. It offers high throughput, supports dApps, and uses the TRX token for transactions and governance. Tron aims to disrupt traditional entertainment industries by providing a platform for content creators to distribute and monetize their content directly to consumers.`
